import React, { useState } from 'react';
import Icon from '../AppIcon';
import { useCompanyBranding } from '../../contexts/CompanyBrandingContext';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Shared company mark for website chrome (Header / Footer).
 * Prefers ERP company-config logo; falls back to icon + i18n brand name.
 */
const CompanyBrandMark = ({
  size = 'md',
  showName = true,
  nameClassName = '',
  iconWrapperClassName = '',
  className = '',
  /** When true (default), hide text label if a logo image is displayed */
  hideNameWhenLogo = true,
  /** Light panel behind logo for dark backgrounds (e.g. footer) */
  onDark = false,
}) => {
  const { logoSrc, displayName } = useCompanyBranding();
  const { t } = useLanguage();
  const [imgFailed, setImgFailed] = useState(false);

  const label = displayName || t('common.brand');
  const showLogo = Boolean(logoSrc) && !imgFailed;
  const renderName = showName && (!showLogo || !hideNameWhenLogo);

  const sizes = {
    sm: { box: 'w-8 h-8', img: 'h-7 w-auto max-w-[140px]', icon: 18, pad: 'px-2 py-1.5' },
    md: { box: 'w-10 h-10', img: 'h-9 w-auto max-w-[180px]', icon: 22, pad: 'px-3 py-2' },
    lg: { box: 'w-11 h-11', img: 'h-11 w-auto max-w-[200px]', icon: 24, pad: 'px-3.5 py-2.5' },
  };
  const s = sizes[size] || sizes.md;

  const logoImage = showLogo ? (
    <img
      src={logoSrc}
      alt={label}
      className={`${s.img} object-contain`}
      onError={() => setImgFailed(true)}
    />
  ) : (
    <span
      className={`${s.box} rounded-lg flex items-center justify-center shrink-0 ${
        iconWrapperClassName || 'bg-primary/10 text-primary'
      }`}
    >
      <Icon name="Building2" size={s.icon} />
    </span>
  );

  return (
    <span className={`inline-flex items-center gap-3 min-w-0 ${className}`}>
      {showLogo && onDark ? (
        <span
          className={`inline-flex items-center justify-center rounded-lg bg-white shadow-sm ${s.pad}`}
        >
          {logoImage}
        </span>
      ) : (
        logoImage
      )}
      {renderName && (
        <span className={`truncate font-bold font-heading ${nameClassName || 'text-xl text-foreground'}`}>
          {label}
        </span>
      )}
    </span>
  );
};

export default CompanyBrandMark;
